import AccountBtns from './AccountBtns';
import CurrencyDropdown from "./CurrencyDropdown";
import LangDropdown from "./LangDropdown";
import AccountData from '../../user/header/AccountData';
import Icons from './Icons';

export default function RightSide({ btns, langs, navbarIsActive, setNavbarIsActive }) {
    const isLoggedIn = localStorage.getItem('token');

    return (
        <div className="right-side flex-center">
            {!isLoggedIn && <AccountBtns btns={btns} />}
            <LangDropdown langs={langs} />
            <CurrencyDropdown />
            {isLoggedIn && <AccountData />}
            <Icons navbarIsActive={navbarIsActive} setNavbarIsActive={setNavbarIsActive} />
        </div>
    );
}